interface Props {
  name: string;
  description: string;
}

const PrizeData = (props: Props): JSX.Element => (
  <section className="tw-container tw-py-4 tw-mx-auto tw-px-4 sm:tw-mx-0 sm:tw-pt-0 sm:tw-px-0">
    <h1 className="tw-mb-5">{props.name}</h1>
    <p className="lg:tw-text-xl tw-overflow-auto">{props.description}</p>
  </section>
);

export default PrizeData;
